module.exports = __webpack_public_path__ + "static/img/ID0_titleBg.419dd90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/ID0_titleBg.png
// module id = lKxO
// module chunks = 0